import { useDrawerStore } from '@nexelem/drawer';
import { Header } from '@nexelem/header';
import type { PropsWithChildren, ReactNode } from 'react';
import EmptyState from '../../../assets/empty-state.svg';
import { cn } from '@nexelem/utils';

type EmptyStatePageProps = {
  headerTitle?: string;
  imageSrc?: string;
  text: ReactNode;
  subtitle?: ReactNode;
  Actions?: ReactNode;
  className?: string;
};

export const EmptyStatePage = ({
  headerTitle,
  imageSrc = EmptyState,
  text,
  subtitle,
  Actions,
  children,
  className,
}: PropsWithChildren<EmptyStatePageProps>) => {
  const isLeftOpen = useDrawerStore((state) => state.left.width > 0);

  return (
    <div className={cn('flex h-full min-h-0 flex-col overflow-hidden pr-8', isLeftOpen ? 'pl-6' : 'pl-8', className)}>
      {headerTitle && (
        <div className="shrink-0">
          <Header title={headerTitle} />
        </div>
      )}
      {children && <div className="shrink-0">{children}</div>}
      <div className="@container-[size] flex min-h-0 flex-1 overflow-auto">
        <div className="m-auto flex flex-col items-center gap-2 py-4 sm:gap-4">
          <img
            alt=""
            aria-hidden="true"
            className="max-h-[min(26.25rem,55cqh)] w-auto max-w-full object-contain"
            src={imageSrc}
          />
          <span className="shrink-0 text-center text-s18 text-text-secondary">{text}</span>
          {subtitle && <span className="shrink-0 text-center text-s16">{subtitle}</span>}
          {Actions && <div className="shrink-0">{Actions}</div>}
        </div>
      </div>
    </div>
  );
};
